import {Text, Stack, Inline} from '@treatwell/ui';
import styles from './OrderDate.module.css';

export type Props = {
  time: string;
  formattedDate: string;
  machineReadableDate: string;
  duration: string;
};

export const OrderDate = ({
  time,
  formattedDate,
  machineReadableDate,
  duration,
}: Props) => {
  return (
    <Inline justify="center">
      <Text as="time" type="mdHero" className={styles.time} dateTime={time}>
        {time}
      </Text>
      <div className={styles.stack}>
        <Stack space="sm">
          <Text
            type="bodyHeavy"
            as="time"
            dateTime={machineReadableDate}
            className={styles.date}
            translate="no"
          >
            {formattedDate}
          </Text>
          <Text type="caption" as="p" className={styles.duration}>
            {duration}
          </Text>
        </Stack>
      </div>
    </Inline>
  );
};
